import script from "./PageBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PageBanner.vue?vue&type=script&setup=true&lang=js"

import "./PageBanner.vue?vue&type=style&index=0&id=04b923ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04b923ec"]])

export default __exports__